import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import PlusThickIcon from 'mdi-react/PlusThickIcon';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess, hasGroupAccess } from "../../Services/SecurityService";
import { check, findAllUsers, findAllUsersByOrgaos, findAllUsersByOrgaoStatus, findUsersById } from "../../Services/UsersService";
import { findAllEstado } from "../../Services/EstadoService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { environment } from '../../environment';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      hasAccess: false,
      selected: {},
      estados: [],
      user: {},
      data: []
    };
    check();
  }

  loadUsers(selected){
    if(hasGroupAccess("ROOT") || hasGroupAccess("ADMINISTRADORES")){
      findAllUsers()
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let user = environment.getUser();
          let userOK = false;
          if(user !== null){
            for(let i = 0; i < data.length; i++){
              if(user.id == data[i].id){
                user = data[i];
                userOK = true;
                break;
              }
            }
          }
          if(userOK){
            this.setState({ data, selected, user, hasAccess: true });
          }else{
            this.loadUser(data, selected, user);
          }
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }else if(hasGroupAccess("PREFEITURAS_ADMINISTRADORES")){
      findAllUsersByOrgaos()
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let user = environment.getUser();
          let userOK = false;
          if(user !== null){
            for(let i = 0; i < data.length; i++){
              if(user.id == data[i].id){
                user = data[i];
                userOK = true;
                break;
              }
            }
          }
          if(userOK){
            this.setState({ data, selected, user, hasAccess: true });
          }else{
            this.loadUser(data, selected, user);
          }
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }else if(hasGroupAccess("PREFEITURAS")){
      findAllUsersByOrgaoStatus()
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
            this.setState({ data: data, selected, hasAccess: true });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }
  }

  loadUser(users, selected, user){
    findUsersById(user.id)
    .then(data => {
      if(data === undefined){
        data = {};
      }
      if(data !== undefined && data.error === undefined){
        if(data.id != null && data.id > 0){
          users.push(data);
        }
        this.setState({ data: users, selected, user: data, hasAccess: true });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(){
    findAllEstado()
    .then(response => {
      if(response === undefined){
        response = [];
      }
      if(response !== undefined && response.error === undefined){
        this.setState({ 
          estados: response
        }, () => {});
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_USER_VIEW")){
        console.log("MENU_USER_VIEW OK");
      this.loadUsers({});
      this.loadEstado();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.setState({ selected });
  }

  setSelectedNew = () => {
    this.setState({ selected: {id: 0} });
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadUsers(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = false;
    let notOK = !hasAccess("MENU_USER_NEW");

    if(this.state.hasAccess){
      if(this.state.selected.id !== null && this.state.selected.id !== undefined){
        disabled = (this.state.selected.id === 0);
        view =  <CrudEdit 
                  selected = {this.state.selected}
                  user = {this.state.user}
                  estados = {this.state.estados}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.users_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.users_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.setSelectedNew()}>
                <PlusThickIcon /> {t('forms.new')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);
